import UserBill from './index';

export default { path: '/home/userBill', component: UserBill };

